// V2 KP Rebuild : comportements communs. Module ES, sans dépendance, sans variable globale.

// Retour en haut : visible après 600 px de défilement ; défilement doux, instantané sous prefers-reduced-motion.
if (!customElements.get('v2-back-to-top')) {
  customElements.define(
    'v2-back-to-top',
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.onScroll = () => this.toggleAttribute('data-visible', window.scrollY > 600);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        this.button.addEventListener('click', () => {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
          const target = document.getElementById('MainContent');
          if (target) target.focus({ preventScroll: true });
        });
      }
      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }
    }
  );
}

// Tiroir mobile : bouton « Fermer » de l'en-tête « Menu » (réutilise la fermeture du header-drawer de Dawn).
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-v2-drawer-close]');
  if (!button) return;
  const drawer = button.closest('header-drawer');
  const summary = drawer && drawer.querySelector('summary');
  if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
  else if (summary) summary.click();
});
